import type { PropsWithChildren } from 'react';
import React from 'react';

import { devError } from '../../utils/log';

type Props = PropsWithChildren;

interface State {
  hasError: boolean;
}

// A malformed banner hides itself instead of taking down the lobby.
export class CategoryBannerErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    devError('Error caught by CategoryBannerErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
